import Axios from '~/utils/axios';
import { useQuery } from 'react-query';
import { sentryCaptureException } from '~/errors/sentry';
type useProfileProps = {
   onSuccess?: (data: any) => void;
};
const useUserProfile = ({ onSuccess }: useProfileProps) => {
   const getUserProfile = async () => {
      const { data = {} } = await Axios.get(`/hy-providers/v1/profile`);
      return data.data ? data.data : data;
   };

   return useQuery(['user-profile'], getUserProfile, {
      refetchOnWindowFocus: false,
      onSuccess,
      onError: (error: Error) => {
         sentryCaptureException(error, { tags: { journey: 'profile' } });
      },
   });
};

export default useUserProfile;
